import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { CARD_BADGE_COLOR_OPTIONS, CARD_BADGE_COLORS } from '../utils/contants';

export default function CardBadge({ children, color }) {
  return (
    <div
      className={classnames(
        'CardBadge inline-flex items-center justify-between br-pill no-select ph2 pv1 font-14',
        CARD_BADGE_COLORS[color]
      )}
      data-test-id="CardBadge"
    >
      <span>{children}</span>
    </div>
  );
}

CardBadge.propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.oneOf(Object.values(CARD_BADGE_COLOR_OPTIONS))
};

CardBadge.defaultProps = {
  color: 'gray'
};
